module.exports = __webpack_public_path__ + "img/Ki.69d1197f.png";